<template>
  <v-card height="271" outlined color="white" class="sigfloCard sigfloNeutralBorder200">
    <div class="d-flex">
      <div>
        <v-img width="64" height="64" :src="getIconImage(system.name)" class="systemIcon mt-5 ml-5" />
      </div>

      <div>
        <div class="systemTitle sigfloH5 black--text ml-8 mt-6">{{ system.name }}</div>
        <div class="systemSubtitle sigfloBodySmall textMuted ml-8 mt-1">
          {{ system.description }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="ml-16"></div>
      <v-card
        width="382"
        height="147"
        outlined
        color="#F9F6FD"
        class="addSystemCard sigfloCard ml-13 mt-4"
        @click="$emit('add-subsystem', system)"
      >
        <v-row>
          <v-col cols="12" class="text-center"
            ><v-icon class="mb-2" color="#BCB2CD" large>mdi-plus-circle-outline</v-icon>
            <div class="button1 sigfloButton">
              {{ getAddText }}
            </div></v-col
          >
        </v-row>
      </v-card>
    </div>
  </v-card>
</template>

<script>
  export default {
    props: {
      system: {
        type: Object,
        required: true
      }
    },
    methods: {},
    computed: {
      /**
       * Returns the text for adding a system.
       *
       * @returns {string} The text for adding a system.
       */
      getAddText() {
        let article = 'a';
        if (
          this.system.name.charAt(0).toLowerCase() === 'a' ||
          this.system.name.charAt(0).toLowerCase() === 'e' ||
          this.system.name.charAt(0).toLowerCase() === 'i' ||
          this.system.name.charAt(0).toLowerCase() === 'o' ||
          this.system.name.charAt(0).toLowerCase() === 'u'
        ) {
          article = 'an';
        }
        return `Add ${article} ${this.system.name} System`;
      }
    }
  };
</script>

<style scoped>
  .addSystemCard {
    padding-top: 25px;
  }
  .systemIcon {
  }
  .systemTitle {
  }
  .systemSubtitle {
  }
  .button1 {
    color: #bcb2cd;
    font-weight: 400 !important;
  }
</style>
